import { render, staticRenderFns } from "./ComplaintsView.vue?vue&type=template&id=0e94da60&scoped=true"
import script from "./ComplaintsView.vue?vue&type=script&lang=js"
export * from "./ComplaintsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e94da60",
  null
  
)

export default component.exports